import { render, staticRenderFns } from "./WorkflowCard.vue?vue&type=template&id=76e9b754&scoped=true"
import script from "./WorkflowCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WorkflowCard.vue?vue&type=style&index=0&id=76e9b754&prod&lang=scss"
import style1 from "./WorkflowCard.vue?vue&type=style&index=1&id=76e9b754&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e9b754",
  null
  
)

export default component.exports